import moment from "moment";
export function convertTime(date: any, format: string) {
  return moment(date).format(format);
}
